import { render, staticRenderFns } from "./Bike.vue?vue&type=template&id=ec17c030&scoped=true&"
import script from "./Bike.vue?vue&type=script&lang=js&"
export * from "./Bike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec17c030",
  null
  
)

export default component.exports